import type { ExternalTableSchema } from '@packages/table-builder';

export const taxSetupApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'Tax Setup Approver',
    entity: 'tax-setup-approval',
    description: 'Review and approve pending tax setup items.',
  },
  dataSource: {
    endpoint: '/api/tax/api/app/tax-item-approval/tax-item-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'taxPeriodId',
        semanticId: 'taxSetupApprovalFilterTaxPeriod',
        placeholder: 'Select Tax Period',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/tax/api/app/tax-period/tax-period',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'taxApprovalStatusId',
        semanticId: 'taxSetupApprovalFilterTaxStatus',
        placeholder: 'Select Tax Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/tax/api/app/tax-item-approval/approval-list',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },
  columns: [
    { field: 'taxPeriodName', header: 'Tax Period', type: 'text', width: 200, sortable: true },
    { field: 'name', header: 'Name', type: 'text', width: 200, sortable: true },
    { field: 'parentTaxItemIdName', header: 'Parent Tax', type: 'text', width: 200, sortable: true },
    { field: 'jurisdictionName', header: 'Jurisdiction Level', type: 'text', width: 200, sortable: true },
    {
      field: 'equityCompensationLevelName',
      header: 'Applicable To',
      type: 'text',
      width: 180,
      sortable: true,
    },
    {
      field: 'incomeYtdTypeDisplayName',
      header: 'Income YTD Type',
      type: 'text',
      width: 180,
      sortable: true,
    },
    {
      field: 'statusDisplayName',
      header: 'Status',
      type: 'badge',
      width: 180,
      sortable: true,
      align: 'center',
      uppercase: true,
      badge: {
        statusMap: {
          Approved: 'success',
          Deactivated: 'error',
          Rejected: 'error',
          Created: 'primary',
          'Pending Approval': 'info',
        },
      },
    },
  ],
  actions: {
    row: [
      { id: 'VIEW_TAX_SETUP_APPROVAL', label: 'View' },
      { id: 'APPROVE_TAX_SETUP_APPROVAL', label: 'Approve' },
      { id: 'REJECT_TAX_SETUP_APPROVAL', label: 'Reject', variant: 'danger' },
      { id: 'VIEW_COMMENT_TAX_SETUP_APPROVAL', label: 'View Comment' },
      { id: 'APPROVAL_HISTORY_TAX_SETUP_APPROVAL', label: 'Approval History' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search…' },
    filterGrid: { columns: 2 },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: {
      persistenceKey: 'Tax Approval',
      resizable: true,
      reorderable: true,
    },
  },
};
